import { trackPageView } from '@finn-no/pulse-sdk';
import type { GetServerSideProps } from 'next';
import { useEffect } from 'react';
import { ConfigProvider } from 'shared/config/ConfigContext';
import { SimpleHead } from 'shared/page/Head';
import { feConfig } from '@/config';
import AboutQasaPage from '@/scenes/aboutQasaPage/AboutQasaPage';
import { runAllMiddlewares } from '../server/middleware';

const Qasa = ({ config }: { config: Record<string, string> }) => {
    useEffect(() => {
        // Fix pulse track id?
        trackPageView({
            object: {
                type: 'Page',
                pageType: 'landingpage',
                category: 'realestate > realestate-lettings-external',
            },
            vertical: {
                name: 'realestate',
                subVertical: 'lettings',
            },
        });
    }, []);

    const description = 'Om Qasa';

    return (
        <>
            <SimpleHead title="FINN eiendom" canonical="https://www.finn.no/realestate/lettings/qasa" description={description} />
            <main className="overflow-hidden m-auto">
                <ConfigProvider config={config}>
                    <AboutQasaPage />
                </ConfigProvider>
            </main>
        </>
    );
};

export const getServerSideProps: GetServerSideProps = async ({ req, res, query }) => {
    await runAllMiddlewares(req, res, query);

    return {
        props: {
            hasLegalBasis: res.locals?.hasLegalBasis ?? false,
            unleash: res.locals?.unleash ?? null,
            config: feConfig,
        },
    };
};

export default Qasa;
